<template>
  <div id="evaluationreport" class="evaluationreport" >

    <b-modal ref="reportModalRef" v-if="selectedEvaluation" id="modalReport" title="Report">
      {{text}}
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'EvaluationReport',
  props: ['text'],
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvaluationReport.vue